module.exports = __webpack_public_path__ + "img/all_head_black copy.d28ca93e.jpg";